import { render } from "./menu_bar.vue?vue&type=template&id=1ef1b6c1&scoped=true"
import script from "./menu_bar.vue?vue&type=script&lang=js"
export * from "./menu_bar.vue?vue&type=script&lang=js"

import "./menu_bar.vue?vue&type=style&index=0&id=1ef1b6c1&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ef1b6c1"]])

export default __exports__